import React from 'react';
import Link from 'gatsby-link';

/**
 * CTA component
 * @param {object} data component props
 * @returns {JSX} JSX for component
 */
const CtaLink = ({ ctaLink, children }) => (
  <React.Fragment>
    {ctaLink && ctaLink.indexOf('http') > -1 ? (
      <a href={ctaLink} rel="noreferrer noopener" target="_blank">
        {children}
      </a>
    ) : (
      <Link to={ctaLink}>{children}</Link>
    )}
  </React.Fragment>
);

export default CtaLink;



// WEBPACK FOOTER //
// ./src/utils/linkRenderer.js